###
 # @desc produces a select box with additional button to create entities of the
 # specified type.
 #
 # @param createForm   the sequenced form id to use on create
 # @param mode         when set to 'multiple', multiple entities can be selected
###

import { useState, useEffect } from 'react'
import { Select, Divider, Input, Button } from 'antd'
import { showActionsPage } from 'Components'
import { Macro } from 'Model'
import { getDataOptions, getRepeatCount } from '../helpers'
import { getProjectData, getNodeLabel, isValidNamespaceUrl } from 'Services/WeaverUtils'
import withDerivedData from './withDerivedData'
import withRepeater from './withRepeater'
{ Option } = Select

SequencedFormSelectOrCreate = ({
  form
  formItem
  label
  config = { mode, showSearch } = {}
  derivedData
  queries
  editPermissions = []
  initializing
  nodeId
  save
  props...
}) ->
  {
    createForm
    mode = undefined
    className
  } = config
  {
    orientation
    relationName
  } = save

  className ?= label

  [disabled, setDisabled] = useState(false)
  [selectOptions, setSelectOptions] = useState([])

  derived = withDerivedData({
    queries,
    derivedData
  })
  { initting, options } = derived

  useEffect( ->
    setSelectOptions(options)
    return if initting or !props.value
    toTest = (val) ->
      if mode is 'multiple'
        val in props.value
      else
        val is props.value

    if !options.find(({ value }) -> toTest(value))
      props.onChange(undefined)
    undefined
  , [options])

  useEffect( ->
    (->
      if orientation is 'IN'
        n = await new Weaver.Query().restrict(nodeId).selectIn(relationName).withRelations().first()
        setDisabled(n.relationsIn[relationName].nodes.length > 1)
      return if initting or !props.value
      isValInOptions = (val) ->
        selectOptions.find(({ value }) -> value is val)
      if mode is 'multiple'
        valid = (props.value or []).filter(isValInOptions)
        if !_.isEqual(valid, props.value) then props.onChange(valid)
      else
        if !isValInOptions(props.value) then props.onChange(undefined)
    )()
    undefined
  , [selectOptions])

  # callback method that will be executed after an entity is created and sets
  # the entity as value for the field that invoked the create-action
  setCreatedItem = (node, data) ->
    { queryLabelAttr } = derivedData
    itemValue = node.id()
    label = getNodeLabel(node)

    setSelectOptions([selectOptions..., { label, value: itemValue }])
    if mode and mode is 'multiple'
      props.onChange([(props.value or [])..., itemValue])
    else
      props.onChange(itemValue)

  <Select
    showSearch
    disabled={disabled}
    mode={mode}
    style={{ width: '100%', marginBottom: 5 }}
    placeholder={if isValidNamespaceUrl(formItem) then formItem else _.startCase(formItem)}
    optionFilterProp="children"
    filterOption={(input, option) ->
      option.children.props.children.join('').toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
    dropdownRender={(menu) -> (
      <div>
        { menu }
        <Divider style={{ margin: '4px 0' }} />
        <div style={{ display: 'flex', flexWrap: 'nowrap', padding: 8 }}>
          <Button
            type="primary"
            onClick={->
              conf = (await Macro.load(createForm)).get('configBlob')
              showActionsPage({ conf..., formCallback: setCreatedItem })
            }
          >
            New { className }
          </Button>
        </div>
      </div>
    )}
    { props... }
  >
    {
      selectOptions.sort((a, b) -> a.attributeValue?.replace(/\D/g,'') - b.attributeValue?.replace(/\D/g,''))
      .map((option) ->
        option.value ?= option
        <Option
          disabled={option.disabled or false}
          key={option.value}
          value={option.value}
        >
          { option.label }
        </Option>
    )}
  </Select>

export default withRepeater(SequencedFormSelectOrCreate, { selector: (value) -> value })
